module.exports = __webpack_public_path__ + "static/media/combination_non_sensitive.a63f92b8.png";